export const BATCH_SPAN_ANNOTATE_TOOL_NAME = "batch_span_annotate";
